import React__default from 'react';
import { be as MOBILE_BREAKPOINT } from './className-0524835a.js';

const onMobile = `(max-width: ${MOBILE_BREAKPOINT}px)`;
function useMediaQuery(query) {
    function getMatches() {
        return window.matchMedia(query).matches;
    }
    const [matches, setMatches] = React__default.useState(getMatches());
    function listener() {
        setMatches(getMatches());
    }
    React__default.useEffect(() => {
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
    });
    return matches;
}
function useOnMobile() {
    return useMediaQuery(onMobile);
}

export { useOnMobile as u };
